import { Component, Input, OnInit } from '@angular/core';
import { ApiPollPost, ApiUser, PollsApi } from '@tytapp/api';
import { UserService } from '@tytapp/user';

@Component({
    selector: 'tyt-petition-updates',
    templateUrl: './petition-updates.component.html',
    styleUrls: ['./petition-updates.component.scss']
})
export class PetitionUpdatesComponent implements OnInit {

    @Input()
    posts: ApiPollPost[];

    @Input()
    pollSlug: string;

    @Input()
    pollId: string;

    user: ApiUser;

    postsToShow: ApiPollPost[];

    constructor(
        private userService: UserService,
        private pollApi: PollsApi
    ) { }

    async ngOnInit() {
        await this.userService.ready;
        this.user = this.userService.user;

        this.userService.userChanged.subscribe((user) => {
            this.user = user;
        });
    }

    async delete(postId: number) {
        if (confirm('Are sure you want to delte the post?')) {
            let result: any = await this.pollApi.deletePollPost(this.pollId, postId).toPromise();

            if (result.success) {
                if (window) {
                    window.location.reload();
                }
            } else {
                alert('There was an error trying to delete the post');
            }
        }
    }

}
